import React, {Component} from 'react';
import {withTranslation} from "react-i18next";

class TextureItem extends Component {
    constructor(props) {
        super(props);
        this.descriptionRef = React.createRef();
        this.imgRef = React.createRef();
    }

    componentDidMount() {
        this.descriptionRef.current.classList.add( 'hideContent' );
    }

    onTextureMouseOver = (e) => {
        this.descriptionRef.current.classList.remove( 'hideContent' );
        let shiftX = (this.imgRef.current.width - this.descriptionRef.current.scrollWidth) / 2;
        //console.log(this.imgRef.current.width + ' : ' + this.descriptionRef.current.scrollWidth + ' :: ' + shiftX);
        this.descriptionRef.current.style.marginLeft = shiftX + 'px';
    };

    onTextureMouseOut = (e) => {
        this.descriptionRef.current.classList.add( 'hideContent' );
    };

    /*onDragStart = (e) => {
        const target = e.target;
        e.dataTransfer.setData('textureId', this.props.dataProvider.id);

        target.classList.add('textureImg');
        console.log('onDragStart');
    };

    onDragOver = (e) => {
        e.stopPropagation();
        console.log('onDragOver : ');
    };*/

    render() {
        const { t } = this.props;
        return (
                <figure className='commonItemContainer'
                        onClick={this.props.onTextureClick}
                        onMouseOver={this.onTextureMouseOver}
                        onMouseOut={this.onTextureMouseOut}
                >
                    <span className="textureTooltip">{t('TEXTURE_CIRCLE_DESCRIPTION')}</span>
                    <img
                        ref={this.imgRef}
                        className="textureImg"
                        src={this.props.dataProvider.iconPath}
                        alt={this.props.dataProvider.description}

                        /*draggable='true'
                        onDragStart={this.onDragStart}
                        onDragOver={this.onDragOver}*/
                    />
                    <figcaption
                        ref={this.descriptionRef}
                        className='textDescription'
                    >
                        {this.props.dataProvider.description}
                    </figcaption>
                </figure>

        );
    }

}
export default withTranslation('common')(TextureItem);